var map = {
	"./demos/basic/index.ts": 27966,
	"./demos/counts/index.ts": 54081,
	"./demos/current/index.ts": 94571,
	"./demos/disable/index.ts": 90220,
	"./demos/flat/index.ts": 77593,
	"./demos/goto/index.ts": 85401,
	"./demos/simple/index.ts": 69992,
	"./demos/size/index.ts": 84493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8636;